import Modal from '../helpers/Modal';
import OrderForm from '../helpers/OrderForm';

export default class TicketModal {
    constructor(root) {
        this.root = root;
        this.checkout = this.root.querySelector('.js-ticket-modal-checkout');
        this.minus_buttons = this.root.querySelectorAll('.js-ticket-modal-minus-ticket');
        this.plus_buttons = this.root.querySelectorAll('.js-ticket-modal-plus-ticket');
        this.ticket_groups = this.root.querySelectorAll('.js-ticket-modal-ticket-group');
        this.order_forms = [];

        window.addEventListener('user-data-received', (event) => {
            if(window.current_user.aaf_member == true) {
                this.ticket_groups.forEach((ticket_group) => {
                    ticket_group.querySelectorAll('.js-ticket-modal-member-item')?.forEach((locked_item) => {
                        locked_item.classList.remove('--locked');
                        this.updateTicketResults(null, locked_item.parentElement.dataset.id, locked_item.nextElementSibling?.dataset.numItems);
                    });
                });
            }
        });

        window.addEventListener('user-data-removed', (event) => {
            this.ticket_groups.forEach((ticket_group) => {
                ticket_group.querySelectorAll('.js-ticket-modal-member-item')?.forEach((unlocked_item) => {
                    unlocked_item.classList.add('--locked');
                });
            });
        });

        window.addEventListener('cart-changed', (event) => {
            this.resetTickets();
            this.updateTicketGroups();
            this.updateTicketValues();
        });

        this.minus_buttons.forEach((minus_button) => {
            minus_button.addEventListener('click', (event) => {
                event.preventDefault();

                let form_data = {};

                if(window.theme.cart.hasItem(minus_button.dataset.id)) {
                    form_data = window.theme.cart.getItem(minus_button.dataset.id).item_data?.form_data;

                    if(form_data) {
                        let count = Object.keys(form_data).length - 1;
                        delete form_data[minus_button.dataset.id + '-' + count];
                    }
                }

                let result = window.theme.cart.remove(minus_button.dataset.id, {form_data: form_data});

                this.updateTicketResults('remove', minus_button.dataset.id, result.count);
                this.updateTicketValues();
            });
        });

        this.plus_buttons.forEach((plus_button) => {
            plus_button.addEventListener('click', (event) => {
                event.preventDefault();

                let result = window.theme.cart.add(plus_button.dataset.id);

                this.updateTicketResults('add', plus_button.dataset.id, result.count);
                this.updateTicketValues();
            });
        });

        this.updateTicketGroups();
        this.updateTicketValues();

        this.modal = new Modal(this.root, (dataset) => {

        },
        () => {
            setTimeout(() => {
                this.root.classList.add('--fade-in-up');
                this.root.classList.remove('--fade-in-left', '--fade-out-right');
            }, 1000);
        });

        this.checkout.addEventListener('click', (e) => {
            e.preventDefault();

            if(this.validateOrderForms() == true) {
                this.root.classList.add('--fade-out-right');
                this.root.classList.remove('--fade-in-left', '--fade-in-up');

                let checkout_modal = this.modal.getModal('cart');
                checkout_modal.root.classList.add('--fade-in-left');
                checkout_modal.root.classList.remove('--fade-out-right', '--fade-in-up');

                setTimeout(() => {
                    this.modal.openAnotherModal('cart');
                }, 500);
            }
        });
    }

    validateOrderForms() {
        let is_valid = true;

        Object.keys(this.order_forms).forEach((order_key) => {
            let order_form = this.order_forms[order_key];
            
            if(order_form) {
                order_form.validate();

                order_form.field_elements.forEach((field_element) => {
                    if(field_element.dataset.hasErrors == 'true') {
                        is_valid = false;
                    }
                });
            }
        });

        return is_valid;
    }

    resetTickets() {
        this.ticket_groups.forEach((ticket_group) => {
            this.getElement('.js-ticket-modal-ticket-container', ticket_group.dataset.id).innerHTML = '';
            this.getElement('.js-ticket-modal-ticket-container', ticket_group.dataset.id).dataset.numItems = '0';
            this.getElement('.js-ticket-modal-total-tickets', ticket_group.dataset.id).innerHTML = '0';
            this.getElement('.js-ticket-modal-plus-ticket', ticket_group.dataset.id).classList.remove('--disabled');
            this.getElement('.js-ticket-modal-minus-ticket', ticket_group.dataset.id).classList.add('--disabled');
        });
    }

    updateTicketResults(action, id, num_tickets) {
        let ticket_container = this.getElement('.js-ticket-modal-ticket-container', id);
        let total_element = this.getElement('.js-ticket-modal-total-tickets', id);
        let plus_button = this.getElement('.js-ticket-modal-plus-ticket', id);
        let minus_button = this.getElement('.js-ticket-modal-minus-ticket', id);

        let max_tickets = 15;

        let max_tickets_membership = parseInt(window.current_user?.membership?.num_members.raw);
        let max_tickets_field = parseInt(total_element.dataset.max);

        if(ticket_container.parentElement.dataset.requiresMembership) {
            if(!isNaN(max_tickets_field) && !isNaN(max_tickets_membership)) {
                max_tickets = Math.min(...[max_tickets_membership, max_tickets_field]);
            } else if (!isNaN(max_tickets_membership)) {
                max_tickets = max_tickets_membership;
            }
        } else if(!isNaN(max_tickets_field)) {
            max_tickets = max_tickets_field;
        } 
        
        if(total_element) {
            if(num_tickets != null) {
                total_element.innerText = num_tickets;
            }

            if(num_tickets == 0) {
                minus_button.classList.add('--disabled');
            } else if(num_tickets >= max_tickets) {
                plus_button.classList.add('--disabled');
            }

            if(num_tickets > 0) {
                minus_button.classList.remove('--disabled');
            } else if(num_tickets < max_tickets) {
                plus_button.classList.remove('--disabled');
            }
        }

        if(ticket_container) {
            if(action == 'remove') {
                let tickets = this.getElements('.js-ticket-modal-ticket', ticket_container.dataset.id, 'ticket-id');

                if(tickets && tickets.length >= 1) {
                    tickets[tickets.length - 1].remove();
                    ticket_container.dataset.numItems = parseInt(ticket_container.dataset.numItems) - 1;
                }
            } else if(action == 'add') {
                ticket_container.appendChild(this.makeTicket(ticket_container.dataset.id, ticket_container.dataset.numItems));
                ticket_container.dataset.numItems = parseInt(ticket_container.dataset.numItems) + 1;
            }
        }
    }

    updateTicketGroups() {
        this.ticket_groups.forEach((ticket_group) => {
            if(window.theme.cart.hasItem(ticket_group.dataset.id)) {
                let item = window.theme.cart.getItem(ticket_group.dataset.id);

                for(let i = 0; i < item.count; i++) {
                    this.updateTicketResults('add', ticket_group.dataset.id, item.count);
                    this.updateTicketValues();
                }

                //lock tickets if membership is required and we aren't logged in
                if(ticket_group.dataset.requiresMembership == true && !window.current_user) {
                    let tickets = this.getElements('.js-ticket-modal-ticket-container', ticket_group.dataset.id);

                    tickets.forEach((ticket) => {
                        ticket.classList.add('--locked', 'js-ticket-modal-member-item');
                    });
                }
            }
        });
    }

    updateTicketValues() {
        let ticket_containers = this.root.querySelectorAll('.js-ticket-modal-ticket-container');
        let num_tickets = 0;

        ticket_containers.forEach((ticket_container) => {
            num_tickets += parseInt(ticket_container.dataset.numItems);
        });

        if(num_tickets == 1) {
            this.root.querySelector('.js-ticket-modal-num-tickets').innerHTML = '1 ticket';
        } else {
            this.root.querySelector('.js-ticket-modal-num-tickets').innerHTML = num_tickets + ' tickets';
        }

        if(num_tickets > 0) {
            this.root.querySelector('.js-ticket-modal-num-tickets').parentElement.classList.remove('--hidden');
            this.checkout.classList.remove('--hidden');
            this.checkout.parentElement.parentElement.classList.remove('--full-height');
        } else {
            this.root.querySelector('.js-ticket-modal-num-tickets').parentElement.classList.add('--hidden');
            this.checkout.classList.add('--hidden');
            this.checkout.parentElement.parentElement.classList.add('--full-height');
        }
    }

    makeTicket(ticket_id, item_count) {
        let return_element = document.createElement('div');
        let repeat_num = 3;

        let ticket_group = this.getElement('.js-ticket-modal-ticket-group', ticket_id);

        return_element.classList.add('modal-ticket__main__ticket');
        return_element.classList.add('js-ticket-modal-ticket');
        return_element.dataset.ticketId = ticket_id;

        if(ticket_group.dataset.orderFormId) {
            for(let i = 0; i < ticket_group.dataset.orderFormRepeat; i++) {
                let order_form = new OrderForm(ticket_group.dataset.orderFormId, ticket_id, item_count, i);
                return_element.appendChild(order_form.render());
                this.order_forms[ticket_id + '-' + item_count] = order_form;
            }
        } else {
            let p_element = document.createElement('p');
            p_element.classList.add('modal-ticket__main__ticket__error-text');

            p_element.innerText = 'This ticket does not have any required fields.';

            return_element.appendChild(p_element);
        }

        return return_element;
    }

    getElement(class_name, id, dataset_variable = 'id') {
        return this.root.querySelector(class_name + '[data-' + dataset_variable + '="' + id + '"]');
    }

    getElements(class_name, id, dataset_variable = 'id') {
        return this.root.querySelectorAll(class_name + '[data-' + dataset_variable + '="' + id + '"]');
    }
}
